<template>
  <div class="header" id="header">
    <div class="header-message" v-for="item in hlist" :key="item.id">
      <div class="header-message-top">
        <div class="message-img">
          <img :src="item.imgUrl ? (url + item.imgUrl) : defaultimg">
        </div>
        <div class="message-infor">
          <p>{{item.title}}</p>
          <p class="level">{{item.level}}</p>
          <router-link tag="button" to="/account_record">账户流水记录</router-link>
        </div>
      </div>
      <div class="header-message-bottom">
        <li>
          <p>{{item.totalincome}}</p>
          <p>收入总额</p>
        </li>
        <li>
          <p>{{item.totalout}}</p>
          <p>消费总额</p>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'MeHeader',
  props: {
    hlist: Array
  },
  data () {
    return {
      url,
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px; margin-top: 10px; padding-bottom: 0;}
.header h2{ margin-bottom: 10px;}
.header-message{ background: linear-gradient(#ed8850, #eb6252); height: 185px; border-radius: 5px; box-shadow: 0 3px 2px #fbcdb8; -moz-box-shadow: 0 3px 2px #fbcdb8; -webkit-box-shadow: 0 3px 2px #fbcdb8;}
.header-message-top{ display: flex;}
.message-img img{ width: 75px; height: 75px; border-radius: 50%; margin: 20px;}
.message-infor{ color: #fff; font-size: 14px; padding-top: 25px; width: 60%;}
.level{ font-size: 12px; margin: 5px 0;}
.message-infor button{ border: 1px solid #fff; background-color: transparent; width: 65%; height: 37px; text-align: center; float: right; color: #fff; border-radius: 3px; line-height: 20px; font-family: Arial,"Microsoft YaHei";}
.header-message-bottom{ display: flex; justify-content: space-around; color: #fff; text-align: center; margin-top: 16px; font-size: 14px;}
li{ list-style-type: none;}
</style>



// WEBPACK FOOTER //
// src/pages/me/components/Header.vue